import React from "react";

export const timeSlicer = (time: Date | null) => {
  if (time !== null) {
    return time.toString().slice(16, 24);
  } else return "";
};
